export default __webpack_public_path__ + "static/media/icons8-dog_park.18c2aebd.svg";